// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2iz5H","rootSuccess":"CompleteLink_rootSuccess__2wdUY","rootFailure":"CompleteLink_rootFailure__4NYee","isDisabled":"CompleteLink_isDisabled__3na4i"};